export default {
	clients_table_id: 'Client ID',
	clients_table_username: 'Telegram Username',
	clients_table_first_name: 'Name',
	clients_table_last_name: 'Surname',
	clients_table_user_id: 'Telegram client ID',
	clients_table_phone: 'Phone number',
	clients_table_email: 'Email',
	clients_table_created_at: 'Registration Date',
	clients_table_last_activity: 'Last client activity',
	clients_table_linked_to_google: 'Linked to Google',
	clients_table_linked_to_google_yes: 'Yes',
	clients_table_linked_to_google_no: 'No',
};